const sessionNotes = {
    N: []
}
export default sessionNotes
